

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CDeleteConfirmModal extends Vue {
    @Prop({ required: true })
    private id!: string;

    @Prop({ required: true })
    private message!: string;

    @Prop({ default: 'danger' })
    private okVariant!: string;

    @Prop({ default: true })
    private danger!: boolean;
}
